const UrlQueryParamTypes = {
  number: 'number',
  string: 'string',
  object: 'object',
  array: 'array',
  json: 'json',
  date: 'date',
  boolean: 'boolean',
  numericObject: 'numericObject',
  numericArray: 'numericArray',
};

export default UrlQueryParamTypes;
